import type { AchievementTemplate } from '@engage/achievement-template/types';
import type { MovementTrackerData } from '@engage/api-v2-models/generated/MovementTrackerData';
import type { MuscleGroupScoreResponse } from '@engage/api-v2-models/generated/MuscleGroupScoreResponse';
import type { Ride } from '@engage/api-v2-models/generated/Ride';
import type { Workout } from '@engage/api-v2-models/generated/Workout';
import type { AxiosPromise } from '../generated/core/request';
import { getWorkout } from '../generated/services/WorkoutsService';

export const workoutDetailsWithMuscleGroupScore = (
  ...args: any[]
): AxiosPromise<
  Workout & {
    achievementTemplates: AchievementTemplate[];
    ride: Ride & {
      muscleGroupScore?: MuscleGroupScoreResponse;
    };
    movementTrackerData?: MovementTrackerData;
    movementTrackerTier: string;
  }
> => getWorkout.apply(this, args);
